import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../@communityshare/ui/card/IconSection';
import { formatDate, formatDateRange } from '../../../utils/dateTimeUtils';

export default function Date(props) {
  const { project } = props;

  if (project.data.specificDate === 'Yes') {
    return (
      <IconSection
        icon={CalendarIcon}
        title={formatDate(project.data.date)}
        tooltip="Date range"
      />
    );
  }

  return (
    <IconSection
      icon={CalendarIcon}
      title={formatDateRange(project.data.startDate, project.data.endDate)}
      tooltip="Date range"
    />
  );
}
